<template>
  <div class="rt-alert">
    <div
      v-show="visible"
      :class="[typeClass, center ? 'is-center' : '', 'is-light']"
      :style="`width:${size}`"
      class="el-alert"
      role="alert"
    >
      <rt-icon
        v-if="showIcon"
        :name="`rt-base-alert-${type}`"
        :class="`rt-alert-${type}`"
        size="16"
      />
      <div class="el-alert__content el-alert__title">
        <slot name="title">
          {{ title }}
        </slot>
      </div>
      <rt-button
        v-show="closable"
        :icon-name="closeText === '' ? 'rt-base-close-x' : ''"
        class="rt-message-close"
        text
        icon-size="16"
        @click="close()"
      >
        <div v-if="closeText">
          {{ closeText }}
        </div>
      </rt-button>
    </div>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon';
import RtButton from '../button/rtButton.vue';

export default {
  name: 'RtAlert',
  components: {
    RtIcon,
    RtButton
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'primary'
    },
    closable: {
      type: Boolean,
      default: true
    },
    closeText: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    showIcon: Boolean,
    center: Boolean
  },

  data () {
    return {
      visible: true
    };
  },

  computed: {
    typeClass () {
      return `rt-alert--${this.type}`;
    }
  },

  methods: {
    close () {
      this.visible = false;
      this.$emit('close');
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtAlert.vue?4a77fbe8